import * as React from "react";
const SvgFilter = (props) => (
  <svg
    width={32}
    height={38}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    {...props}
  >
    <path fill="#622FEE" d="M.06 0h32v40h-32z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.06 13a1 1 0 1 0-2 0v6h-6a1 1 0 1 0 0 2h6v6a1 1 0 0 0 2 0v-6h6a1 1 0 1 0 0-2h-6v-6Z"
      fill="#FAFAFA"
    />
  </svg>
);
export default SvgFilter;
